import React from 'react'
import { useParams } from 'react-router-dom'
import { NavigationHeader } from '@/components/NavigationHeader/NavigationHeader'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { PermissionDto } from 'api/Identity/Types/PermissionDto'
import { PermissionsEnum } from 'api/Identity/Types/PermissionsEnum'
import { IntroducingBrokerDetailedProfileDto } from 'api/Trading-Accounts/Types/IntroducingBrokerDetailedProfileDto'
import { useTabNavigate } from 'hooks/useTabNavigate'
import { hasPermission } from 'utils/permissionsValidator'

import { IntroducingBrokerProfileTypes } from './types'

type IntroducingBrokerProfileTemplateProps = {
  profile: IntroducingBrokerDetailedProfileDto
  permissions: PermissionDto[]
  children: React.ReactNode
}

export const IntroducingBrokerProfileTemplate: React.FC<IntroducingBrokerProfileTemplateProps> = (
  props
) => {
  const params = useParams<{ id: string; slug: string }>()
  const tabNavigate = useTabNavigate()

  const activeTab = params.slug || IntroducingBrokerProfileTypes.DETAILS

  return (
    <>
      <NavigationHeader>
        {props?.profile?.name && <span>{props.profile.name}</span>}
      </NavigationHeader>

      <Tabs value={activeTab} onValueChange={tabNavigate} className='mt-2'>
        <TabsList>
          {hasPermission(props.permissions, PermissionsEnum.CanViewIntroducingBrokerProfile) && (
            <TabsTrigger value={IntroducingBrokerProfileTypes.DETAILS}>Details</TabsTrigger>
          )}

          {hasPermission(props.permissions, PermissionsEnum.CanViewIntroducingBrokerProfile) && (
            <TabsTrigger value={IntroducingBrokerProfileTypes.ACCOUNT_GROUP}>
              Account Groups
            </TabsTrigger>
          )}

          {hasPermission(props.permissions, PermissionsEnum.CanViewIntroducingBrokerProfile) && (
            <TabsTrigger value={IntroducingBrokerProfileTypes.IBS}>IBS</TabsTrigger>
          )}

          {hasPermission(props.permissions, PermissionsEnum.CanViewIntroducingBrokerProfile) && (
            <TabsTrigger value={IntroducingBrokerProfileTypes.INSTRUMENTS}>Instruments</TabsTrigger>
          )}
        </TabsList>
      </Tabs>

      {props.children}
    </>
  )
}
